import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Card, CardBody, Col, Row, Spinner } from "reactstrap";
import { getReplacementPricingAssets } from "../../services/PricingService";

const UserPanel = () => {
  const [pricedAssetsCount, setPricedAssetsCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadPricedAssetsCount = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await getReplacementPricingAssets({
          pricingStatus: "priced",
          page: 0,
          size: 1,
        });
        const payload = response?.data?.data ?? {};
        if (!isMounted) return;
        setPricedAssetsCount(Number(payload.total_count ?? 0));
      } catch (err) {
        if (!isMounted) return;
        console.error("Failed to load priced assets count:", err);
        setError("Failed to load priced assets count.");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadPricedAssetsCount();
    return () => {
      isMounted = false;
    };
  }, []);

  const cards = useMemo(() => [
    {
      title: "Assets With Pricing",
      value: loading ? "..." : pricedAssetsCount.toLocaleString(),
      icon: "ri-money-dollar-circle-line",
      trend: "Assets already assigned unit replacement cost",
      link: "/asset-pricing?pricingStatus=priced&autoSearch=1",
      clickable: true,
    },
    {
      title: "PAPs",
      value: "435",
      icon: "ri-community-line",
      trend: "Compensation cases in scope",
    },
    {
      title: "Clients",
      value: "435",
      icon: "ri-user-star-line",
      trend: "Organizations currently tracked",
    },
    {
      title: "Partner Companies",
      value: "435",
      icon: "ri-building-4-line",
      trend: "Linked delivery partners",
    },
  ], [loading, pricedAssetsCount]);

  return (
    <React.Fragment>
      {error ? (
        <Row className="g-4 mb-3">
          <Col xl={12}>
            <Alert color="warning" className="mb-0">{error}</Alert>
          </Col>
        </Row>
      ) : null}
      <Row className="g-4">
        {cards.map((card) => (
          <Col xl={3} sm={6} key={card.title}>
            <Card className={`dashboard-widget metric-card ${card.clickable ? "metric-card-clickable" : ""}`}>
              <CardBody tag={card.link ? Link : "div"} to={card.link || undefined} className="text-decoration-none d-block">
                <div className="d-flex justify-content-between align-items-start gap-3">
                  <div>
                    <p className="metric-label mb-2">{card.title}</p>
                    <h3 className="metric-value mb-2">
                      {loading && card.title === "Assets With Pricing" ? <Spinner size="sm" color="primary" /> : card.value}
                    </h3>
                    <p className="metric-trend mb-0">
                      <strong>Live</strong> {card.trend}
                    </p>
                  </div>
                  <div className="metric-icon">
                    <i className={card.icon}></i>
                  </div>
                </div>
                {card.clickable ? (
                  <div className="metric-link mt-3">View priced assets</div>
                ) : null}
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};

export default UserPanel;
